<template>
  <div>
    <br />
    <h2 class="ViewHeading">System Management</h2>
    <div>
      <b-row
        ><b-col>
          <h4>{{ this.selectedlocation }}</h4>
        </b-col></b-row
      >
      <b-card>
        <b-tabs>
          <b-tab lazy title="Sys Management"></b-tab>

        </b-tabs>
      </b-card>
      <b-row
        ><b-col><br /></b-col
      ></b-row>
    </div>
  </div>
</template>

<script>

export default {
  computed: {},
  components: {

  },

  data() {
    return {
      
      selectedlocation: localStorage.getItem("CurrentLocation"),
    };
  },

  beforeMount() {},

  mounted() {},

  methods: {},
};
</script>

<style>

</style>
